module.exports = __webpack_public_path__ + "static/organic-search-row-two-hero-right-54832da4c92205c4bf2498968fc0bbdd.jpg";